import { getModuleLoader } from 'emscripten-wasm-loader';
import { cldLoader } from 'cld3-asm/dist/esm/cldLoader';
import * as browserRuntimeModule from 'cld3-asm/dist/esm/lib/browser/cld3';

const runtime =
  typeof browserRuntimeModule === 'function'
    ? browserRuntimeModule
    : typeof browserRuntimeModule?.default === 'function'
    ? browserRuntimeModule.default
    : null;

export const loadBrowserModule = async (initOptions = {}) => {
  if (!runtime) {
    throw new Error('cld3 browser runtime is not a function');
  }

  const { timeout } = initOptions;
  const moduleLoader = await getModuleLoader(runtimeInstance => cldLoader(runtimeInstance), runtime, undefined, {
    timeout,
  });

  return moduleLoader();
};
